import { jsx } from "react/jsx-runtime";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { validateTidalLicense } from "../../base/index.js";
function ChatBubbleOutline(props) {
  return /* @__PURE__ */ jsx(
    ChatBubbleOutlineIcon,
    {
      "data-testid": "ChatBubbleOutline",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ChatBubbleOutline",
      "data-tidal-icon-meta": "chat,customerService"
    }
  );
}
ChatBubbleOutline.tidalIconMeta = {
  categories: "chat,customerService",
  name: "ChatBubbleOutline"
};
validateTidalLicense();
export {
  ChatBubbleOutline
};
//# sourceMappingURL=ChatBubbleOutline.js.map
